import React, { useContext } from 'react';

import { AppContext } from 'src/components/app-context';
import { ProductImage } from 'src/components/product-image';

import type { RelatedProduct } from '../../../../types';
import type { OnSelect } from '../../types';

import * as S from './styles';

type Props = {
  showNewComparePageLayout: boolean;
  relatedProductsAsOverlay: boolean;
  onSelect: OnSelect;
  relatedProducts: RelatedProduct[];
};

const RelatedProducts = ({
  relatedProducts,
  relatedProductsAsOverlay,
  onSelect,
  showNewComparePageLayout,
}: Props) => {
  const { t } = useContext(AppContext);

  return (
    <S.RelatedProducts relatedProductsAsOverlay={relatedProductsAsOverlay}>
      <S.RelatedProductsTitle>
        {t('product', 'recommendations.similar-products')}
      </S.RelatedProductsTitle>
      <S.RelatedProductsSubTitle>
        {t('compare', 'related-products.add')}
      </S.RelatedProductsSubTitle>

      {relatedProducts.map(relatedProduct => {
        const product = relatedProduct.product;

        if (!product) return null;

        const onClickHandler = (e: React.MouseEvent<HTMLElement>) => {
          e.preventDefault();
          onSelect(product);
        };

        return (
          <S.ProductRow
            key={`related-product-${product.id}`}
            onClick={onClickHandler}
            name={product.name}
            price={product.priceSummary.regular}
            image={
              product.media.first && (
                <ProductImage name={product.name} src={product.media.first} />
              )
            }
            showDivider
            showNewComparePageLayout={showNewComparePageLayout}
          />
        );
      })}
    </S.RelatedProducts>
  );
};

export default RelatedProducts;
